// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"calendar"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 10H3V21H21V10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21 10H3V5H21V10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 10H21M3 10V5H21V10M3 10V21H21V10M7 5V1.5M17 5V1.5","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-calendar')
export default class CalendarIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar',
    }
  }
}
